import { getValueAsEvent as g } from "../../../utils/helpers.form.js";
import { getQueryRangeExclusive as k } from "../../../utils/helpers.label-value.js";
import { useRef as l, useCallback as E, useEffect as A } from "react";
const q = ({
  autoSelect: u = !0,
  debouncedQuery: t,
  debounceThreshold: r = 500,
  onChange: e,
  queryRef: i,
  results: n,
  setTypedQuery: f,
  setValue: m
}) => {
  const p = l(), x = l(""), a = l([]), o = E(
    (c) => {
      const s = B(
        t,
        c,
        n,
        u
      );
      s && (m(s.result), e == null || e(g(s.result), s.result), p.current !== "Backspace" && (f(s.result.label), setTimeout(
        () => {
          var v, y;
          return (y = (v = i.current) == null ? void 0 : v.input) == null ? void 0 : y.setSelectionRange(...s.queryIndex);
        },
        Math.max(r * 0.2, 10)
      )));
    },
    [
      t,
      n,
      u,
      f,
      m,
      e,
      r,
      i
    ]
  ), R = E((c) => {
    p.current = c == null ? void 0 : c.key;
  }, []);
  return A(() => {
    x.current === t && a.current === n || (x.current = t, a.current = n, t && o(0));
  }, [t, o, n]), {
    highlightQueryByActiveIndex: o,
    setKeyPressed: R
  };
}, B = (u, t, r = [], e) => {
  if (typeof t != "number" || !e || !r[t])
    return;
  const i = k(
    u,
    r[t].label
  );
  return i ? {
    queryIndex: i,
    result: r[t]
  } : void 0;
};
export {
  q as useComboboxInlineCompletion
};
